export const SET_SCRIPTS = 'SET_SCRIPTS';



// WEBPACK FOOTER //
// ./src/store/reducers/scripts/actionTypes.js